// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2EYca","productName":"Table_productName__3Tp0u"};